import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getCourseTaskInfo = (payload) => httpClient.get(apis.getCourseTaskInfo(payload));

export const getPersonalTaskInfo = (payload) => httpClient.get(apis.getPersonalTaskInfo(payload));

export const checkAndAddCourseTask = (payload) =>
  httpClient.get(apis.checkAndAddCourseTask(payload));

export const addByClassidCourseTask = (payload) =>
  httpClient.get(apis.addByClassidCourseTask(payload));

export const generateFile = ({ courseId, bookId, fileId }) =>
  httpClient.get(`${apis.GET_GENERATE_FILE}/${courseId}/${bookId}/${fileId}`);
